export function formatDate(dateString) {
	if (!dateString) return "-";
	const date = new Date(dateString);
	return date.toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

export function formatNumber(value) {
	if (value === null || value === undefined) return "-";
	return value.toLocaleString("pt-BR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}
